/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const SearchMinus: React.FC<Props> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.61035 1.45269C14.1159 1.45272 17.7686 5.10478 17.7686 9.60992C17.7685 11.5926 17.0601 13.4092 15.8838 14.8228L18.3281 17.2671L18.3799 17.3238C18.6199 17.6184 18.6026 18.0532 18.3281 18.3277C18.0536 18.602 17.6187 18.6195 17.3242 18.3794L17.2676 18.3277L14.8232 15.8834C13.4096 17.059 11.5927 17.7671 9.61035 17.7671C5.10511 17.767 1.45238 14.1148 1.45215 9.60992C1.45215 5.10487 5.10497 1.45286 9.61035 1.45269ZM9.61035 2.95269C5.9332 2.95286 2.95215 5.93349 2.95215 9.60992C2.95238 13.2861 5.93334 16.267 9.61035 16.2671C13.2875 16.2671 16.2683 13.2862 16.2686 9.60992C16.2686 5.93341 13.2876 2.95272 9.61035 2.95269ZM11.5605 8.86089C11.9747 8.86097 12.3105 9.19673 12.3105 9.61089C12.3103 10.0249 11.9745 10.3608 11.5605 10.3609H7.66309C7.24902 10.3609 6.91333 10.0249 6.91309 9.61089C6.91309 9.19668 7.24887 8.86089 7.66309 8.86089H11.5605Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default SearchMinus;
